import superAdmin from "./superAdmin";
import admin from "./admin";
import common from "./common";
import user from "./user";
import assessment from "./assessments";

export default {
    common: common,
    admin: admin,
    superAdmin: superAdmin,
    user: user,
    assessment: assessment
}